@if (!ppNotification) {
  <div class="spinner" [ngClass]="class"></div>
}

@if (ppNotification) {
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
}
